module.exports = __webpack_public_path__ + "static/media/boy1.30d54ff6.svg";